export const slider = (theme) => ({
  root: {
    position: "relative",
    "& .slick-disabled": {
      border: `4px solid transparent`,
      opacity: 0.25,
    },
  },
  slider: {},
  slider2: {
    "& .slick-track": { padding: "0 20% 0 0" },
  },
  equalHeight: {
    "& .slick-track": { display: "flex !important" },
    "& .slick-slide": { height: "inherit !important" },
    "& .slick-slide > div": { height: "100%" },
  },
  arrows: {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    marginBottom: 20,
  },
  icon: {
    display: "block",
    height: 32,
    width: 32,
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "calc(50% - 16px)",
  },
  arrow: {
    cursor: "pointer",
    marginTop: theme.spacing(2),
    marginRight: "0",
  },
  back: {
    height: 60,
    width: 60,
    //border: `4px solid ${theme.customPalette.secondaryYellowYButtons}`,
    borderRadius: "50%",
    marginLeft: "0",
    boxSizing: "border-box",
  },
  next: {
    height: 60,
    width: 60,
    //border: `4px solid ${theme.customPalette.secondaryYellowYButtons}`,
    borderRadius: "50%",
    marginLeft: "0",
    boxSizing: "border-box",
  },
});
